import areObjsEqualByKey from '@glass/shared/helpers/utils/areObjsEqualByKey';

const createMemoPropKeys = (keys) => (prevProps, nextProps) =>
  areObjsEqualByKey(keys, prevProps, nextProps);

export default createMemoPropKeys;
